import { render, staticRenderFns } from "./WapPay.vue?vue&type=template&id=8c9e1902&"
import script from "./WapPay.vue?vue&type=script&lang=js&"
export * from "./WapPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports